import {
  SET_BENE_REVAMP_FORM_VALUES,
  TOGGLE_REDIRECTED_FROM_SEND_MONEY,
  RESET_NEW_BENE_FLOW_STATE,
  IS_BENE_SCHEMA_ENABLED,
  SET_PAYOUT_API_RESPONSE,
  SET_SCHEMA_API_RESPONSE,
  SET_NON_SCHEMA_COUNTRIES_API_RESPONSE,
  SET_RECEIVING_METHOD_BANK_ACCOUNT_COUNTRY_VALUES,
  PUSH_NAVIGATION_HISTORY,
  POP_NAVIGATION_HISTORY,
  CLEAR_NAVIGATION_HISTORY,
  SET_CURRENT_BENE,
  TOGGLE_IS_EDIT_BENE_FLOW,
  SET_SELECTED_COUNTRY_MOBILE_CODE,
  RESET_FORM_VALUES_STATE,
  SET_IS_SELF_BENE,
  SET_POPULAR_COUNTRIES,
  SET_ADDRESS_CONFIG,
  SET_PAYOUT_LABEL,
  SET_BENE_BANK_NAME,
  SET_UNFILTERED_CURRENT_BENE,
  SET_CURRENT_BENE_ID,
  SET_CURRENT_FORM_BENE_ADDRESS,
  TOGGLE_SHOULD_PREFILL_BENE_ADDRESS
} from '@Redux/action-contants';
import { screenNames } from '../../../screens/beneficiary-flow/constants';
import { BeneficiaryFlowState } from '../../../screens/beneficiary-flow/types';
import { popularCountries } from '../../../screens/beneficiary-flow/pages/receiving-method/utils/constants';

const INITIAL_STATE: BeneficiaryFlowState = {
  isBeneSchemaEnabled: false,
  isSelfBene: false,
  currentScreen: screenNames.receiving_method.name,
  formValues: {
    account_type: '',
    currency_code: '',
    bank_account_country: '',
    payout_method: '',
    routing_config_type_temp: ''
  },
  payoutApiResponse: {},
  schemaApiResponse: {},
  nonSchemaCountriesApiResponse: {},
  redirectedFromSendMoney: false,
  receivingMethodBankAccountCountryValues: [],
  navigationHistory: {
    stack: []
  },
  selectedCountryMobileCode: '',
  isEditFlow: false,
  //@ts-ignore
  popularCountries: popularCountries,
  popularCountriesFetched: false,
  addressConfig: {},
  payoutLabel: '',
  beneficiaryBankName: null
};

const setFormValues = (
  currentValues: Record<string, string | number>,
  valueObject: Record<string, string | number>
) => {
  const result = { ...currentValues };
  for (const [key, value] of Object.entries(valueObject)) {
    result[key] = value;
  }
  return result;
};

export default function newBeneficiaryReducer(state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case IS_BENE_SCHEMA_ENABLED: {
      return {
        ...state,
        isBeneSchemaEnabled: action.data
      };
    }

    case SET_IS_SELF_BENE: {
      return {
        ...state,
        isSelfBene: action.data
      };
    }

    case SET_BENE_REVAMP_FORM_VALUES: {
      return {
        ...state,
        formValues: setFormValues(state.formValues, action.data)
      };
    }
    case SET_PAYOUT_API_RESPONSE: {
      return {
        ...state,
        payoutApiResponse: action.data
      };
    }
    case SET_SCHEMA_API_RESPONSE: {
      return {
        ...state,
        schemaApiResponse: action.data
      };
    }
    case SET_NON_SCHEMA_COUNTRIES_API_RESPONSE: {
      return {
        ...state,
        nonSchemaCountriesApiResponse: action.data
      };
    }
    case TOGGLE_REDIRECTED_FROM_SEND_MONEY: {
      return {
        ...state,
        redirectedFromSendMoney: action.data
      };
    }

    case SET_RECEIVING_METHOD_BANK_ACCOUNT_COUNTRY_VALUES: {
      return {
        ...state,
        receivingMethodBankAccountCountryValues: action.data
      };
    }

    case RESET_FORM_VALUES_STATE: {
      return {
        ...state,
        formValues: INITIAL_STATE.formValues
      };
    }
    case RESET_NEW_BENE_FLOW_STATE: {
      return INITIAL_STATE;
    }

    case PUSH_NAVIGATION_HISTORY: {
      return {
        ...state,
        currentScreen: action.data,
        navigationHistory: {
          stack: [...(state.navigationHistory?.stack || []), state.currentScreen]
        }
      };
    }

    case POP_NAVIGATION_HISTORY: {
      const newStack = state.navigationHistory?.stack.slice(0, -1) || [];
      const poppedScreen = state.navigationHistory?.stack.slice(-1)[0];
      return {
        ...state,
        currentScreen: poppedScreen || INITIAL_STATE.currentScreen,
        navigationHistory: {
          stack: newStack
        }
      };
    }

    case CLEAR_NAVIGATION_HISTORY: {
      return {
        ...state,
        currentScreen: INITIAL_STATE.currentScreen,
        navigationHistory: {
          stack: []
        }
      };
    }

    case SET_CURRENT_BENE: {
      return {
        ...state,
        currentBene: action.data
      };
    }

    case SET_UNFILTERED_CURRENT_BENE: {
      return {
        ...state,
        unfilteredCurrentBene: action.data
      };
    }

    case TOGGLE_IS_EDIT_BENE_FLOW: {
      return {
        ...state,
        isEditFlow: action.data
      };
    }

    case SET_SELECTED_COUNTRY_MOBILE_CODE: {
      return {
        ...state,
        selectedCountryMobileCode: action.data
      };
    }

    case SET_POPULAR_COUNTRIES: {
      return {
        ...state,
        popularCountries: action.data,
        popularCountriesFetched: true
      };
    }

    case SET_ADDRESS_CONFIG: {
      return {
        ...state,
        addressConfig: action.data
      };
    }

    case SET_PAYOUT_LABEL: {
      return {
        ...state,
        payoutLabel: action.data
      };
    }
    case SET_BENE_BANK_NAME: {
      return {
        ...state,
        beneficiaryBankName: action.data
      };
    }

    case SET_CURRENT_BENE_ID: {
      return {
        ...state,
        currentBeneId: action.data
      };
    }

    case SET_CURRENT_FORM_BENE_ADDRESS: {
      return {
        ...state,
        currentFormBeneAddress: action.data
      };
    }

    case TOGGLE_SHOULD_PREFILL_BENE_ADDRESS: {
      return {
        ...state,
        shouldPrefillBeneAddress: action.data
      };
    }
    default:
      return state;
  }
}
